export type PageContextType = {
    id: string;
    type: string;
    lang: string;
    uid: string;
    url: string;
};

export const PrismicLocales = ['en-us', 'fr-fr', 'es-es', 'ja-jp', 'de-de', 'pt-pt', 'it-it'];

export enum SupportedLanguages {
    en = 'en',
    fr = 'fr',
    es = 'es',
    ja = 'ja',
    de = 'de',
    pt = 'pt',
    it = 'it',
}

export const supportedHomePages: string[] = Object.values(SupportedLanguages).map(
    languageAbbreviation => `home-${languageAbbreviation}`,
);

export const languagesListCopyMapping: {
    [key: string]: string;
} = {
    en: `English`,
    fr: `Français`,
    es: `Español`,
    ja: `日本語`,
    de: `Deutsch`,
    pt: `Português`,
    it: `Italiano`,
};

export type AlternateLanguage = {
    lang: string;
    uid: string;
    type: string;
    id: string;
};

export interface Jsonp extends jest.Mock {
    _mockError: (message: string) => void;
    _mockSuccess: (data: any) => void;
}

// Many of these supported params are listed in the Registration Form repository
// Might be worth story sharing the values between the registration form and
// the guest site through the core models repo
export type SupportedURLParams = {
    plan?: string;
    code?: string;
    planFrequency?: string;
    returnUrl?: string;
    couponCode?: string;
    utm_source?: string;
    utm_campaign?: string;
    utm_medium?: string;
    utm_content?: string;
    utm_term?: string;
    homePage?: string;
    availableAuthenticationMethods?: string;
    locale?: string;
    callToActionChoiceFacebook?: string;
    callToActionChoiceEmail?: string;
    callToActionEmailSubmit?: string;
    callToActionEmailLogin?: string;
    switchToLoginText?: string;
    switchToLoginCta?: string;
    switchToRegisterText?: string;
    switchToRegisterCta?: string;
    referralCode?: string;
    tenant?: string;
    partner?: string;
    theme?: string;
    mode?: string;
    showRememberMe?: string;
};
